// MST1020_R01 BOM 관련 유틸리티 함수 및 상수

import { allowedAccountsArr } from "src/components/common/common";
import { showWarning } from "src/utils/toast/toastUtil";
import { SYS4030_R01Dto } from "./Dto_SYS4030_R01";


export const headerNames_SYS4030_R01: Record<string, string> = {
	rowIndex: "",
	warehouseCd: '창고번호',
	warehouseNm: '창고명',
	displaySeq: '순서',
	inoutType: '내외부구분',
	logicCenter: '물류센터',
	compCd: '사업자명',
	customCd: '거래처명',
	materialYn: '자재창고사용',
	goodsYn: '상품창고사용',
	productYn: '제품창고사용',
	manufactYn: '공정창고사용',
	badYn: '불량창고사용',
	fifiYn: '선입선출',
	useYn: '사용여부',
	approveFlg: '승인여부',
	remark: '비고',
}

// 원본 데이터 복구 함수
export function restoreOriginalValues(
  valueIndex: number,
  originalData: SYS4030_R01Dto,
  updateSYS4030_R01List: (index: number, data: SYS4030_R01Dto) => void,
  gridRef: any
) {
  setTimeout(() => {
    updateSYS4030_R01List(valueIndex, {
      ...originalData,
      isModified: originalData.inserted === true ? false : true
    });
    if (gridRef.current?.api) {
      const allRowNodes: any[] = [];
      gridRef.current.api.forEachNode((node: any) => {
        if (node.data && node.data.valueIndex === valueIndex) {
          allRowNodes.push(node);
        }
      });
      if (allRowNodes.length > 0) {
        const targetNode = allRowNodes[0];
      }
    }
  }, 100);
}

// 행 편집 가능 여부
export function isEditableRow(
  params: any,
  originalSYS4030_R01List: SYS4030_R01Dto[],
  deletedSYS4030_R01List: (string | number)[]
): boolean {
  if (params.data?.inserted) return true;
  const originalData = originalSYS4030_R01List.find(item => item.valueIndex === params.data?.valueIndex);
  return true;
}

// 날짜 컬럼 클릭 시 편집 가능 여부
export function validateDateColumns(
  field: string,
  data: any,
  originalSYS4030_R01List: SYS4030_R01Dto[],
  dateColumns: string[]
): boolean {
  const originalData = originalSYS4030_R01List.find(item => item.valueIndex === data.valueIndex);
  return true;
}

// 품목 계정 검증
export function validateItemAccount(itemAccount: string) {
  return allowedAccountsArr.includes(itemAccount);
}